import React from 'react';
import { connect } from "react-redux";
import Loader from '../Global/loader.js';
import './main.css';
import clientLogin from './../API/Login'
import Logo from './../images/color_logo.png'
import { withNamespaces } from 'react-i18next';
import { Dropdown, Form } from 'react-bootstrap'
import Flags from 'country-flag-icons/react/1x1'
import getUserInfo from './../API/Client/GetUserInfo'
import logout from '../Global/logout.js';
import ReactNotification from 'react-notifications-component'
import history from './../history'

export class Login extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            error: false,
            signin: false,
            username: "",
            password: ""        
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);     
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit= async (e) => {
        e.preventDefault()
        await this.setState({ signin: true })

        const login = await clientLogin(this.state.username,this.state.password)     
        
        if(login.error){
            this.setState({ error: login.error.response.data.responseMessage })            
        }
        else{
            sessionStorage.setItem("token", login.data.token)

            /* Get user info and save it */
            let userInfo = await getUserInfo()

            if(userInfo.data.status === 401){
                logout() 
            }
            else{
                await this.props.mapState("MAP_ALL_INFO", userInfo.data.data)
                this.changeLanguage(userInfo.data.data.user_web_properties.settings.language)
            }
            // set theme color 
            document.documentElement.className = "";      
            document.documentElement.classList.add(`theme-`+ this.props.user.user_web_properties.settings.themeColor);
            history.push("/dashboard")
        }

        this.setState({ signin: false })
      
    }  

    componentDidMount(){
        if (sessionStorage.getItem("token") !== null) {
            history.push("/dashboard")     
        } 

        //set document ittle
        const { t } = this.props
        let naslov =  t('Login')
        document.title = naslov
    }

    changeLanguage(lng) { 
        const { i18n } = this.props         
        i18n.changeLanguage(lng);
    };

    
    render(){          
        const {signin, error} = this.state     
        const { t } = this.props
         
    return(
        
        <main className="admin_login" role="main">
                {signin ?
                    <Loader/>                                   
                :       
                <> 
                    <div className="languageDropdown">
                        <ReactNotification />
                        <Dropdown>
                            <Dropdown.Toggle variant="default" id="dropdown-basic">
                                {this.props.lng === 'hr' ?
                                    <Flags.HR title="Croatia" className="flag" />
                                :
                                    <Flags.US title="United States" className="flag" />
                                }
                            </Dropdown.Toggle>

                            <Dropdown.Menu >
                            <Dropdown.Item href="#" >
                                    <Flags.HR
                                        title="united states" 
                                        className="flag"
                                        onClick={() => this.changeLanguage('hr')}
                                    />
                                </Dropdown.Item>    
                                <Dropdown.Item href="#">
                                    <Flags.US
                                        title="united states" 
                                        className="flag"
                                        onClick={() => this.changeLanguage('en')}
                                    />
                                </Dropdown.Item>                       
                            </Dropdown.Menu>
                        </Dropdown> 
                    </div>  
                     
                    <div className="login"> 
                        <img src={Logo} alt="logo"/>
                        <form className="form-signin">
                           <Form.Control   
                                type="text" 
                                id="username" 
                                name="username" 
                                placeholder={t('Username')} 
                                defaultValue={this.state.username} 
                                onChange={this.handleChange} 
                            />
                    
                           <Form.Control   
                                type="password" 
                                placeholder={t('Password')} 
                                defaultValue={this.state.password} 
                                onChange={this.handleChange}
                                id="password" 
                                name="password"                                 
                            />                            
                            { error ? 
                                <p className="error-color">{error}</p>
                            : null }     
                            <button 
                                className="btn btn-lg btn-primary btn-block"                                 
                                onClick={(e) =>this.handleSubmit(e)}
                            > 
                                {t('Login')} 
                            </button>
                        </form>                      
                    </div>
                 </>                       
                }   
        </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        language: state.user.defaultLanguage,
        user: state.user
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(withNamespaces()(Login));
